import React from "react";
import { useSelector } from "react-redux";
import { FieldSet } from "@sigeco/tools";
import makeStyles from "@material-ui/core/styles/makeStyles";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import useMediaQuery from "@material-ui/core/useMediaQuery";

const useStyles = makeStyles(() => ({
    root: {
        display: "flex",
        flex: "1 1 auto",
        flexDirection: "column",
        overflow: "hidden",
        //padding: "0 2rem",
    },
    content: {
        padding: "0.5rem 0.75rem 0.75rem",
    },
    tableWrap: {
        flex: "1 1 auto",
        overflow: "hidden",
    },
}));

const MiEspacioArchivo = () => {
    const classes = useStyles();
    //const big = useMediaQuery("(min-width:1201px)");
    const middle = useMediaQuery("(min-width:701px)");
    const selected = useSelector((state) => state.cargarmiespacio.store.selected);
    const item = selected[0];
    return (
        <FieldSet className={classes.root} iconCls="fa fa-rocket" title="Mi Espacio">
            <Grid className={classes.content} container spacing={1}>
                <Grid container item spacing={1} xs={12}>
                    <Grid item xs={middle ? 4 : 8}>
                        <TextField
                            fullWidth
                            label="Nombre"
                            value={item.nombre}
                            variant={middle ? "outlined" : "standard"}
                            inputProps={{
                                readOnly: true,
                            }}
                        />
                    </Grid>
                    <Grid item xs={middle ? 2 : 6}>
                        <TextField
                            fullWidth
                            label="Tipo"
                            value={item.tipo}
                            variant={middle ? "outlined" : "standard"}
                            inputProps={{
                                readOnly: true,
                            }}
                        />
                    </Grid>
                </Grid>
                <Grid item xs={12}>
                    <div style={{ marginTop: "1rem" }}>
                        {item.tipo === "imagen" && (
                            <img
                                src={item.uri}
                                alt={item.nombre}
                                style={{ maxWidth: "80%", maxHeight: "400px", border: "1px solid #ccc" }}
                            />
                        )}

                        {item.tipo === "video" && (
                            <video controls style={{ width: "80%", maxHeight: "400px", border: "1px solid #ccc" }}>
                                <source src={item.uri} type="video/mp4" />
                                Tu navegador no soporta la reproducción de video.
                            </video>
                        )}

                        {item.tipo === "pdf" && (
                            <iframe
                                src={item.uri}
                                style={{ width: "80%", height: "400px", border: "1px solid #ccc" }}
                                title="Visor PDF"
                            />
                        )}

                        {!["imagen", "video", "pdf"].includes(item.tipo) && (
                            <p>No se puede visualizar este tipo de archivo.</p>
                        )}
                    </div>
                </Grid>
            </Grid>
        </FieldSet>
    );
};

export default MiEspacioArchivo;
